import type { FC, ReactNode } from 'react'

import LiveClock from '@/components/generals/live-clock'
import Img from '@/components/generals/img'
import { stores } from '@/constants/site'

const StoresList: FC = (): ReactNode => {
    return (
        <ul className='border-t border-line'>
            {stores.map(store => (
                <li key={store.city} data-reveal='up' className='group grid grid-cols-[auto_1fr] gap-5 border-b border-line py-6 md:gap-7'>
                    <div className='relative aspect-[4/5] w-24 overflow-hidden bg-coal md:w-32'>
                        <Img
                            src={store.image}
                            alt={store.imageAlt}
                            sizes='128px'
                            className='transition-transform duration-[1.2s] ease-expo-out group-hover:scale-110'
                        />
                    </div>

                    <div className='flex min-w-0 flex-col justify-between gap-3'>
                        <div className='flex items-start justify-between gap-4'>
                            <p className='meta-mono text-ash'>
                                ({store.district})
                            </p>

                            <p className='flex items-center gap-2 meta-mono text-bone'>
                                <span className='ping' aria-hidden='true' />

                                <LiveClock timeZone={store.timeZone} />
                            </p>
                        </div>

                        <h3 className='font-heading text-[clamp(40px,4.6vw,72px)] uppercase leading-[0.88] text-bone transition-colors duration-500 group-hover:text-acid'>
                            {store.city}
                        </h3>

                        <div>
                            <p className='body-copy text-bone/75'>
                                {store.address}
                            </p>

                            <p className='mt-1 meta-mono text-ash'>
                                {store.hours}
                            </p>
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    )
}

export default StoresList
